import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchClientExitChecklistListResponse>}
 */

export function requestClientExitChecklistListList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/client-exit-checklist`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/client-exit-checklist?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestCreateClientExitChecklist(value) {
  return fetch.post(`${BASE_URL}/api/app/client-exit-checklist`, {
    ...value,
  });
}

export function requestUpdateClientExitChecklist(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/client-exit-checklist/${data._id}`, body);
}
